export default __webpack_public_path__ + "static/media/LogoPolice805.aff298c2.png";